// "Searches" dropdown in the /v2/sequences subnav.
//
// Click to open, click-outside or Escape to close. Written plain rather than
// as a Bootstrap dropdown so the book-styled bar keeps its own markup and CSS
// instead of inheriting Bootstrap's panel chrome. Turbo Drive is disabled app
// wide (see application.js), so DOMContentLoaded is the right hook.
document.addEventListener('DOMContentLoaded', function () {
  var menus = Array.prototype.slice.call(document.querySelectorAll('[data-sequence-menu]'));
  if (!menus.length) return;

  function triggerFor(menu) {
    return menu.querySelector('[data-sequence-menu-trigger]');
  }

  function closeAll() {
    menus.forEach(function (menu) {
      menu.classList.remove('open');
      var trigger = triggerFor(menu);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  menus.forEach(function (menu) {
    var trigger = triggerFor(menu);
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var willOpen = !menu.classList.contains('open');
      closeAll();

      if (willOpen) {
        menu.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-sequence-menu]')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var open = menus.filter(function (menu) { return menu.classList.contains('open'); })[0];
    if (!open) return;

    closeAll();

    // Send focus back to the trigger so keyboard users are not dropped at the
    // top of the document after dismissing the panel.
    var trigger = triggerFor(open);
    if (trigger) trigger.focus();
  });
});
